/*!
    * @product/scmp-sdk 1.0.191
    * 2ee70241639e6ca63aaacf31294551dd6dda7662
  */
function n(){if(!(typeof window>"u"))return window}export{n as a};
//# sourceMappingURL=chunk-BODNEJOX.js.map
